if (window.location.pathname === "/inyeccion") {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#tablaInyeccion tbody");
    const filtroMes = document.getElementById("filtroMes");
    const filtroAño = document.getElementById("filtroAño");

    if (tableBody && filtroMes && filtroAño) {

        let cargando = false;
        let timeoutFiltro = null;

        function formatearNumero(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString("en-US");
        }

        async function actualizarTabla() {
            if (cargando) return;
            if (document.hidden) return;

            cargando = true;

            const mes = filtroMes.value;
            const anio = filtroAño.value;

            const url = `/api/inyeccion?filtroMes=${mes}&filtroAnio=${anio}`;

            try {
                const response = await fetch(url, requestOptions);

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const result = await response.json();
                const data = result.result;

                tableBody.innerHTML = "";

                if (!data || !data.resultado || data.resultado.length === 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data");

                    row.innerHTML = `
                        <td colspan="7">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;

                    tableBody.appendChild(row);
                    return;
                }

                data.resultado.forEach(function (item) {
                    const row = document.createElement("tr");

                    row.innerHTML = `
                        <td><a href="inyeccion/periodo?mes=${item.mesPeriodo}&año=${item.anioPeriodo}">${item.periodo}</a></td>
                        <td>${formatearNumero(item.totalProduccion)}</td>
                        <td>${formatearNumero(item.totalBueno)}</td>
                        <td>${formatearNumero(item.totalMalo)}</td>
                        <td>${formatearNumero(item.porcBueno)}%</td>
                        <td>${formatearNumero(item.porcMalo)}%</td>
                        <td>${formatearNumero(item.totalMinutosMuertos)}'</td>
                    `;

                    tableBody.appendChild(row);
                });

            } catch (error) {
                console.error("Error en tabla inyección:", error);

                if (typeof lanzarAlerta === "function") {
                    lanzarAlerta("No se pudo actualizar la tabla de inyección.", "alerta-roja");
                }

            } finally {
                cargando = false;
            }
        }

        function actualizarConDebounce() {
            clearTimeout(timeoutFiltro);

            timeoutFiltro = setTimeout(function () {
                actualizarTabla();
            }, 200);
        }

        filtroMes.addEventListener("input", actualizarConDebounce);
        filtroAño.addEventListener("input", actualizarConDebounce);

        actualizarTabla();

        setInterval(function () {
            actualizarTabla();
        }, 120000);
    }
}